// messages.js
export const ToastMessages = {
  FETCH_RESPONSE_FAILURE: 'Failed to fetch Response data',
  FETCH_RESPONSE_ERROR: 'Error fetching Response data',
};

export const DefaultTexts = {
  LOADING_RESPONSES: 'Loading responses...',
  RESPONSES: 'Responses',
  NO_RESPONSES: 'No responses available for this form.',
  LOADING: 'Loading...',
  CSV_FILENAME: 'responses.csv',
};
export const typeTexts ={
  individualType : "Individual",
  summary :"Summary",
  questions :"Questions"
}
